import createDocument from "../../utils/createDocument";

import createDiscussionChannelData from "./createDiscussionChannelData";

export default function createDiscussionChannel(firebase, data) {
	const discussionChannel = createDiscussionChannelData(firebase, data);

	return createDocument(discussionChannel);
}
